export interface OverlayProps {
  activeLocale: string;
  setLocale: (locale: string) => void;
  closeAllUI: () => void;
  immortalleCollected: boolean;
  almondCollected: boolean;
  sheaButterCollected: boolean;
  lavenderCollected: boolean;
  toggleInstructions: () => void;
  activeScene: string;
  setActiveScene: (scene: string) => void;
  audioModal: boolean;
  setAudioModal: (state: boolean) => void;
  playTransitionVideo: (videoName: string, room: string) => void;
  audioActive: boolean;
  toggleAudio: () => void;
  resetAudioToHub: () => void;
}

export interface OutOfStockProps {
  activeLocale: string;
  active: boolean;
  setActive: (state: boolean) => void;
}
export interface DrawerItemProps {
  scene: string;
  heading: string;
  subHeading: string;
  handler: () => void;
}
export interface DrawerMenuItemProps {
  active: boolean;
  heading: string;
  subHeading: string;
}
export interface LoadingProps {
  activeLocale: string;
  isAudioModalOpened: boolean;
  setLoadUI: () => void;
}

export interface MockLoadingProps {
  videoUrl: string;
  setLoadUI: () => void;
}
export interface WelcomeProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface CongratulationsProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface ImmortelleProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface LavenderProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface AlmondProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface ButterProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}

export interface SecretGardenProps {
  isLocked: boolean;
  active: boolean;
  setActive: () => void;
}

export interface SecretGardenDiscountProps {
  active: boolean;
  setActive: () => void;
}
export interface InstructionsProps {
  activeLocale: string;
  active: boolean;
  setActive: () => void;
}
export interface InstructionsItemProps {
  activeLocale: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Icon: any;
  text: string;
}
export interface TransitionalVideoProps {
  activeLocale: string;
  videoURL: string;
  room: string;
  playing: boolean;
  setPlaying: () => void;
  resetTransitionVideo: () => void;
}

export interface ImageSliderProps {
  activeLocale: string;
  highlightImage: string;
  images: string[];
  setHighLightImage: (image: string) => void;
  setShowTryOn: (value: boolean) => void;
  hasTryOn: boolean;
}

export interface InstructionsSliderProps {
  activeLocale: string;
  highlightImage: string;
  images: string[];
  setHighLightImage: (image: string) => void;
  setShowTryOn: (value: boolean) => void;
  hasTryOn: boolean;
}
export interface SizeProps {
  size: string;
  selectedSize: string;
  setSelectedSize: (size: string) => void;
}

export interface ColorProps {
  color: string;
  selectedColor: string;
  setSelectedColor: (size: string) => void;
}

export interface ToastProps {
  activeLocale: string;
  borderColor: string;
  toastActive: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any;
}

export interface RoomItemProps {
  activeLocale: string;
  alignRight: boolean;
  rightIcon?: boolean;
  divider?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any;
  itemText: string;
  onClick?: () => void;
}

export interface TransitionalVideo {
  videoURL: string;
  active: boolean;
  gotoRoom: string;
}
export interface AudioToggleModalProps {
  activeLocale: string;
  active: boolean;
  proceedAudio: (state: boolean) => void;
}
export interface ARViewModalProps {
  active: boolean;
  setActive: () => void;
}
export interface PDPProps {
  activeLocale: string;
  pdpData?: ProductData;
  active: boolean;
  productMetaData: ProductMetaData;
  setActive: (state: boolean) => void;
}

export interface GeneralImagePopUpProps {
  url: string;
  active: boolean;
  setActive: (state: boolean) => void;
}

export interface AudioLayerProps {
  playAudio: boolean;
}

export interface CloseIconProps {
  handler: () => void;
}

export interface LavenderFactOneItemProps {
  activeLocale: string;
  imageUrl: string;
  textOne: string;
  textTwo: string;
}

export interface ProductData {
  id: string;
  collection: string;
  product_sku: string;
  title: string;
  description: string;
  short_description: string;
  category: string;
  currency: string;
  default_url: string;
  base_price: string;
  variants_selection_order: string[];
  variants: ProductVariant[];
}

export interface ProductMetaData {
  organisationName: string | null;
  experienceName: string | null;
  roomName: string;
  browser: string;
  os: string;
}

export interface ProductVariant {
  default: boolean;
  variant_id: string;
  variant_sku: string;
  variants: { variant_type: string; value: string }[];
  available_stock: number;
  media: ProductMedia[];
  momenti_url: string;
  retail_price: string;
  sale_price: string;
  availability: string;
}

export interface ProductMedia {
  url: string;
  main: ConstrainBoolean;
  thumbnail_url: string;
  media_type: string;
  mobile_version_url: string;
}

export const EmptyProductData = {
  id: '',
  collection: '',
  product_sku: '',
  title: '',
  description: '',
  short_description: '',
  category: '',
  currency: '',
  default_url: '',
  base_price: '',
  variants_selection_order: [],
  variants: [],
};
